'use client';

import { Wizard } from '@/components/wizard/Wizard';

import { RdsCdcFlow } from './rdsCdcFlow';
import {
  defaultRdsCdcWizardState,
  type RdsCdcWizardState,
} from './rdsCdcWizardState';

interface RdsCdcWizardPanelProps {
  resourceId: string;
  onAbort: () => void;
  onFinished: () => void;
}

export function RdsCdcWizardPanel({
  resourceId,
  onAbort,
  onFinished,
}: RdsCdcWizardPanelProps) {
  return (
    <Wizard<RdsCdcWizardState>
      onAbort={onAbort}
      hideBackArrow={false}
      onFinish={async () => {
        onFinished();
        return false;
      }}
      flow={[RdsCdcFlow]}
      initialState={{
        ...defaultRdsCdcWizardState,
        resourceId,
      }}
      title='RDS CDC Setup'
      stepperLabels={['PrivateLink', 'SQL Setup', 'Final Checks']}
    />
  );
}
